export default __webpack_public_path__ + "static/media/Foto27.53abd94b.png";